// Handles the advisories, grabs the data and does the work of animation, process data and datareqest objects
var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Live = OCS.Viewer.Live || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions.define_advisory_manager = function () {
    OCS.Viewer.Classes.AdvisoryManager = new Class({
        Extends: OCS.Viewer.Classes.SingletonManager,
        class_name: "AdvisoryManager",
        manager_name: 'AdvisoryManager',
        dataset_obj: null,
        last_update_recieved: null,
        get_initial_data: true, // This this back upon confirmation of server-side geoJSON capabilities
        actively_retrieve_advisories: true, // Turn this to true on confirmation of the availability of the GeoJSON format.
        wfo_id_to_group: null,
        group_to_wfo_id: null,
        warning_types_to_group: null,
        group_to_warning_types: null,
        bound_methods: {},
        options: {
            actively_retrieve_data: true,
            data_request_keys: ['dataset', 'variables', 'grid'],
            dataset: 'edu.ou.ocs.advisories',
            draw_type_lat_lon: 'lat_lon',
            subscribe_to_all: false,
            debug: false
        },
        advisory_update_timeout: null,
        init: function (op) {
            this.setOptions(op);
            this.wfo_id_to_group = new OCS.Classes.ListManager({debug: this.options.debug});
            this.group_to_wfo_id = new OCS.Classes.ListManager({debug: this.options.debug});
            this.warning_types_to_group = new OCS.Classes.ListManager({debug: this.options.debug});
            this.group_to_warning_types = new OCS.Classes.ListManager({debug: this.options.debug});
            this.initialize_events();
            if (OCS.Viewer.Functions.use_workers()) {
                this.dataworker_activation = setTimeout(this.start_data_worker.bind(this), OCS.Viewer.Config.dataworker_start_time);
                OCS.Viewer.Functions.get_event_manager().subscribe({event_name: OCS.Viewer.Config.events.DATAWORKER_ONLINE, callback: this.on_dataworker_online.bind(this), fire_immediately: true, once: true});
            }
            this.gm = OCS.Viewer.Functions.get_geometry_manager();
            this.get_dataset_obj();
        },
        initialize_events: function () {
            this.addEvent('refresh', this.on_refresh.bind(this));

        },

        /*
         * 
         * Event fires
         * 
         */

        advisory_update: function () {
            // Make sure we are clear of advisory updates before sending.
            if(this.advisory_update_timeout) {
                clearTimeout(this.advisory_update_timeout);
            }
            this.advisory_update_timeout = setTimeout(function() {
                this.advisory_update_timeout = null;
                this.fireEvent('advisory_update', this);
            }.bind(this), 10);
        },

        /*
         * 
         * Event Listeners
         * 
         */
        on_dataworker_message: function (event) {
            var data_obj, dataset;
            if (event.cmd) {
                switch (event.cmd) {
                    case 'data':
                        dataset = OCS.Functions.get_dataset_from_node(event.options.entry.json.dataset);
                        if (dataset.options.dataset === this.options.dataset) {
                            data_obj = OCS.Functions.define_data_obj(event.options);
                            var data_json = data_obj.json();
                            if (data_json.data && ((data_json.data.type === "Feature" && data_json.data.properties) || (data_json.data.features && data_json.data.features.length))) {
                                this.process_data(data_obj);
                            }

                        }
                        break;
                }
            }
        },
        on_dataworker_online: function () {
            this.subscribe();
            this.init_data();
        },
        on_refresh: function () {
            if (OCS.Viewer.WorkerState.online) {
                this.get_initial_data = true;
                this.init_data();
            }
        },

        /*
         * 
         * Actions
         * 
         */

        init_data: function () {
            if (this.get_initial_data) {
                this.send_data_worker_message({'cmd': 'get_data', 'options': this.get_data_request_options()});
            }
        },

        register: function (id, adv_ops) {
            var changed = false;
            // Geographical preferences
            var util = OCS.Viewer.Functions.get_utilities();
            if (adv_ops.hasOwnProperty('filter_wfo_ids')) {
                if (!adv_ops.filter_wfo_ids) {
                    if (!this.wfo_id_to_group.is_list_key_in_use('*')) {
                        changed = true;
                    }
                    this.wfo_id_to_group.register('*', id);
                    this.group_to_wfo_id.register(id, '*');
                } else {
                    // Associate this callback with the wfo_ids its interested in
                    if (adv_ops.filtered_wfo_ids && typeof adv_ops.filtered_wfo_ids === 'string') {
                        adv_ops.filtered_wfo_ids = adv_ops.filtered_wfo_ids.toUpperCase().split(/[\s,]+/);
                    }
                    util.parse_item_or_list(adv_ops.filtered_wfo_ids, function (key) {
                        if (!this.wfo_id_to_group.is_list_key_in_use(key)) {
                            changed = true;
                        }
                        this.wfo_id_to_group.register(key, id);
                        this.group_to_wfo_id.register(id, key);
                    }.bind(this));

                }
            }

            if (adv_ops.hasOwnProperty('warning_types')) {
                if (adv_ops.warning_types && typeof adv_ops.warning_types === 'string') {
                    adv_ops.warning_types = adv_ops.warning_types.toUpperCase().split(/[\s,]+/);
                }
                util.parse_item_or_list(adv_ops.warning_types, function (key) {
                    if (!this.warning_types_to_group.is_list_key_in_use(key)) {
                        changed = true;
                    }
                    this.warning_types_to_group.register(key, id);
                    this.group_to_warning_types.register(id, key);

                }.bind(this));
            } else {
                // If the all indicator is not in use, this would represent a change
                if (!this.warning_types_to_group.is_list_key_in_use('*')) {
                    changed = true;
                }
                this.warning_types_to_group.register('*', id);
                this.group_to_warning_types.register(id, '*');

            }

            // We are not going to actually change anything since we are subscribed to everything.
            if (this.options.subscribe_to_all) {
                changed = false;
            }
            if (changed) {
                // Refresh the data
                this.fireEvent('refresh', null, 1);
            }
        },
        unregister: function (id) {
            var changed = true;
            if (this.wfo_id_to_group.is_list_key_in_use('*')) {
                // Since we are subscribed to everything, we may not need to make a change afterall.
                changed = false;
            }
            this.wfo_id_to_group.unregister(id);
            this.group_to_wfo_id.make_list_key_inactive(id);
            this.group_to_warning_types.make_list_key_inactive(id);
            if (!this.wfo_id_to_group.is_list_key_in_use('*') && !changed) {
                // We are no longer subscribed to all stations, we made a change
                this.options.subscribe_to_all = false;
                changed = true;
            }

            // Refresh the data if changed
            if (changed) {
                this.fireEvent('refresh', null, 1);
            }

        },
        process_data: function (data) {
            var dateObj = OCS.Functions.get_OCSDateTime();
            this.parse_geojson_advisory(data.json());
            this.last_update_recieved = dateObj.get_server_epoch_time();
            this.advisory_update();
        },
        parse_geojson_advisory: function (json_adv) {
            /* istanbul ignore else */
            if (json_adv.data.type === 'Feature') {
                this.parse_geojson_feature(json_adv.data);
            } else if (json_adv.data && json_adv.data.features instanceof Array && json_adv.data.features.length) {
                Object.each(json_adv.data.features, this.parse_geojson_feature.bind(this));
            }
        },
        parse_geojson_feature: function (feature) {
            var adv_data = OCS.Advisories.Functions.store_advisory_data(feature.properties, {'advisory_update': this.advisory_update.bind(this)});
            if(feature.geometry) {
                new OCS.Geometry.Classes.GeoJsonFeatureData({
                    geometry: feature.geometry,
                    properties: {
                        simplified: 0,
                        sid: adv_data.last_event.get_geom_event_key()
                    },
                    crs: {type: 'name', properties: {name: OCS.Viewer.Config.default_projection}},
                });
            }

        },

        /**
         * Get the advisories that are active at a given timestamp
         * 
         * @method get_advisories
         * @author Kenneth Jackson
         * @param map_datetime {Obj} Map related time object.
         * @param group_id {String}  The group_id that is requestiong the information for determining what wfo_ids to filter off of for that group
         * @return {array} An array of all the active advisory objects.
         */
        get_advisories: function (map_datetime, group_id) {
            // Use map start and end times
            var data_class = OCS.Functions.define_Data_class();
            var stale = this.get_stale_threshold();
            var start = map_datetime.get_start_epoch_time() - stale;
            var end = map_datetime.get_end_epoch_time() + stale;
            return new data_class({entry: {json: {data: OCS.Advisories.Functions.retrieve_advisory_data(start, end, this.group_to_wfo_id.get_list_key_elements(group_id), this.group_to_warning_types.get_list_key_elements(group_id)), dataset: this.options.dataset, info: {parm: "advisories", timestamp: end}}}});
        },


        /**
         *
         * @param sid String
         * @returns {*}
         */

        remove_old_advisories: function (earliest_timestamp) {
            var data_keys, i, d;
            data_keys = Object.keys(OCS.Data.Advisories);
            for (i = 0; i < data_keys.length; i++) {
                d = OCS.Advisories.Functions.get_adv(data_keys[i]);
                if (d.is_expired(earliest_timestamp)) {
                    d.destroy();
                }
            }
        },
        subscribe: function () {
            this.send_data_worker_message({'cmd': 'subscribe_init', 'options': this.get_data_request_options()});

        },
        unsubscribe: function () {
            this.send_data_worker_message({'cmd': 'subscribe_terminate', 'options': this.get_data_request_options()});
        },

        /*
         * 
         * Get / Set Methods
         * 
         */
        get_data_request_options: function (force) {
            var last = this.get_last_update_recieved();
            if (!last) {
                last = this.get_earliest_timestamp();
            }

            var dateObj = OCS.Functions.get_OCSDateTime();
            var long_start, long_end;
            var query_url_ops = {proj: OCS.Viewer.Config.default_projection};

            long_start = dateObj.get_utc_long_string(this.get_earliest_timestamp());
            long_end = dateObj.get_utc_long_string(this.get_latest_timestamp());
            query_url_ops.date_params = '&start=' + long_start + '&end=' + long_end;

            var wfo_ids = this.wfo_id_to_group.get_active_keys();
            if (this.wfo_id_to_group.is_list_key_in_use('*') || this.options.subscribe_to_all || !wfo_ids.length) {
                wfo_ids = Object.keys(OCS.Constants.NWS_STATIONS.stations);
            }
            var variables = [];
            if (wfo_ids.length > 0) {
                var wfo_ids_string = wfo_ids.join(',');
                query_url_ops.wfo_param = '&wfo=' + wfo_ids_string;
                wfo_ids.each(function (wfo_id) {
                    variables.push({wfo: wfo_id});
                });
            }

            return {
                url: this.get_query_url(query_url_ops),
                dataset: this.get_dataset(),
                node_path: this.get_node_path(),
                data_type: 'GeoJsonData',
                variables: variables
            };
        },
        get_dataset: function () {
            return this.options.dataset;
        },
        get_dataset_obj: function () {
            if (!this.dataset_obj) {
                var dataset = this.get_dataset();
                /* istanbul ignore else */
                if (dataset && OCS.Datasets[dataset]) {
                    this.dataset_obj = OCS.Datasets[dataset];
                } else {
                    this.dataset_obj = new OCS.Classes.Dataset();
                }
            }
            return this.dataset_obj;
        },
        get_earliest_timestamp: function () {
            var dateObj = OCS.Functions.get_OCSDateTime();
            return dateObj.get_start_epoch_time();
        },
        get_latest_timestamp: function () {
            var dateObj = OCS.Functions.get_OCSDateTime();
            return dateObj.get_end_epoch_time();
        },
        get_last_update_recieved: function () {
            return this.last_update_recieved;
        },
        get_stale_threshold: function () {
            return this.get_dataset_obj().getOption('stale_threshold');
        },
        get_node_path: function () {
            return this.get_dataset_obj().get_node_path();
        },
        get_query_url: function (op) {
            return this.get_dataset_obj().get_query_url(op);
        },

        /* 
         * Destroy Methods
         */
        destroy: function () {
            if(this.advisory_update_timeout) {
                clearTimeout(this.advisory_update_timeout);
                this.advisory_update_timeout = null;
            }
            if (this.dataworker_activation_timeout) {
                clearTimeout(this.dataworker_activation_timeout);
                this.dataworker_activation_timeout = null;
            }            
            this.remove_registered_events();
            if (this.options.debug) {
                console.debug('Advisory Manager: Destroying!');
            }
            this.destroy_manager();
        }
    });
    OCS.Viewer.Classes.AdvisoryManager.implement(OCS.Viewer.Interfaces.DataAccessor);
    OCS.Viewer.Classes.AdvisoryManager.implement(OCS.Viewer.Interfaces.DataWorker);
    OCS.Viewer.Functions.get_advisory_manager = function (ops) {
        if (!OCS.Viewer.Live.AdvisoryManager) {
            new OCS.Viewer.Classes.AdvisoryManager(ops);
        }
        return OCS.Viewer.Live.AdvisoryManager;
    };
};
OCS.Viewer.Functions.define_advisory_manager();

